/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { Int32GenericApiResponseFromJSON, ReservationCreateUpdateDtoToJSON, ReservationDtoGenericApiResponseFromJSON, ReservationDtoSortedPagedListResponseGenericApiResponseFromJSON, ReservationWithProtocolDtoListGenericApiResponseFromJSON, SuccessfullApiResponseFromJSON, } from '../models';
/**
 *
 */
export class ReservationApi extends runtime.BaseAPI {
    /**
     */
    apiReservationAddPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Reservation/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ReservationCreateUpdateDtoToJSON(requestParameters.reservationCreateUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiReservationAddPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReservationAddPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiReservationDeleteIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiReservationDeleteIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Reservation/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiReservationDeleteIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReservationDeleteIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiReservationFindByGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.filtersCustomerIds) {
                queryParameters['Filters.CustomerIds'] = requestParameters.filtersCustomerIds;
            }
            if (requestParameters.filtersCarId !== undefined) {
                queryParameters['Filters.CarId'] = requestParameters.filtersCarId;
            }
            if (requestParameters.filtersCarModelIds) {
                queryParameters['Filters.CarModelIds'] = requestParameters.filtersCarModelIds;
            }
            if (requestParameters.filtersFrom !== undefined) {
                queryParameters['Filters.From'] = requestParameters.filtersFrom.toISOString();
            }
            if (requestParameters.filtersTo !== undefined) {
                queryParameters['Filters.To'] = requestParameters.filtersTo.toISOString();
            }
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Reservation/FindBy`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ReservationDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiReservationFindByGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReservationFindByGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiReservationGetAllGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Reservation/GetAll`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ReservationDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiReservationGetAllGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReservationGetAllGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiReservationGetIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiReservationGetIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Reservation/Get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ReservationDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiReservationGetIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReservationGetIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiReservationNotendedGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Reservation/notended`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ReservationWithProtocolDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiReservationNotendedGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReservationNotendedGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiReservationUpdatePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Reservation/Update`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ReservationCreateUpdateDtoToJSON(requestParameters.reservationCreateUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiReservationUpdatePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReservationUpdatePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
